import type { FiltekProduct } from '../types/filtek'
import { brand } from './palette'

/** Three members and one cousin. That is the whole family. */
export const products: FiltekProduct[] = [
  {
    id: 'supreme',
    name: 'Filtek Supreme',
    shortName: 'Supreme',
    descriptor: 'The aesthetic one',
    form: 'sculptable',
    role: 'member',
    kinship: 'The one you reach for when the case is going to be looked at closely.',
    accent: brand.supreme,
    claim: 'Full control of shade, opacity and translucency — layer by layer.',
    facts: [
      { label: 'Shade system', value: '36 shades, 4 opacities' },
      { label: 'Built for', value: 'Anterior layering, demanding aesthetics' },
      { label: 'Filler', value: 'Nanofiller technology' },
      { label: 'Finish', value: 'High gloss, retained over years' }
    ]
  },
  {
    id: 'easy-match',
    name: 'Filtek Easy Match',
    shortName: 'Easy Match',
    descriptor: 'The everyday one',
    form: 'sculptable',
    role: 'member',
    kinship: 'The one that covers most of the week without a shade debate.',
    accent: brand.easyMatch,
    claim: 'Three options cover the everyday range. The shade puzzle disappears.',
    facts: [
      { label: 'Shade system', value: '3 options: Light, Medium, Dark' },
      { label: 'Built for', value: 'Everyday anterior and posterior work' },
      { label: 'Chairside effect', value: 'Blends to surrounding tooth structure' },
      { label: 'Inventory', value: 'Fewer shades to stock and decide between' }
    ]
  },
  {
    id: 'bulk',
    name: 'Filtek Bulk',
    shortName: 'Bulk',
    descriptor: 'The efficient one',
    form: 'bulk',
    role: 'member',
    kinship: 'The one that gets a deep posterior case done in a single increment.',
    accent: brand.bulk,
    claim: 'Fill, sculpt, cure. One increment up to 5 mm.',
    facts: [
      { label: 'Increment', value: 'Up to 5 mm, single placement' },
      { label: 'Built for', value: 'Class I and II posterior restorations' },
      { label: 'Stress', value: 'Low polymerisation shrinkage stress' },
      { label: 'Steps saved', value: 'No capping layer required' }
    ]
  },
  {
    id: 'warmer',
    name: 'Filtek Composite Warmer',
    shortName: 'Composite Warmer',
    descriptor: 'The cousin',
    form: 'warmer',
    role: 'cousin',
    kinship: 'Not a composite at all — it makes the other three handle better.',
    accent: brand.warmer,
    claim: 'Warm what you already use. Lower viscosity, better adaptation, same material.',
    facts: [
      { label: 'Works with', value: 'Supreme, Easy Match and Bulk' },
      { label: 'Effect', value: 'Lower viscosity, improved cavity adaptation' },
      { label: 'Holds', value: 'Syringes and capsules, ready at the chair' },
      { label: 'Changes', value: 'Handling only — not your material choice' }
    ]
  }
]

export const productById = (id: string): FiltekProduct =>
  products.find((product) => product.id === id) ?? products[0]
